import { h, Fragment, cloneElement } from "preact";

import classname from "../../../foundation/utils/classname";
import Chip, { ChipBackground } from "../Chip";

import styles from "./TogglePill.module.css";

interface Props {
    class?: string;
    label: string;
    icon: JSX.Element;
    value: string;
    chips?: { label: string; value: string; }[];
    selected: boolean;
    disabled?: boolean;
    onChange(value: string): void;
}

function TogglePill({
    class: cssClass,
    label,
    icon,
    value,
    chips,
    selected,
    disabled = false,
    onChange
}: Props) {
    function handleClick(event: MouseEvent) {
        event.stopPropagation();

        onChange(value);
    }

    const coloredIcon = cloneElement(icon, {
        color: disabled ? "var(--label-disabled)" : "var(--label-primary)"
    });

    return (
        <button
            class={classname(styles.togglePill, "body-1", cssClass, {
                [styles.selected]: selected,
                [styles.disabled]: disabled
            })}
            disabled={disabled}
            onClick={handleClick}>
            {coloredIcon}
            {label}
            {selected && chips && (
                <>
                    <div class={styles.chipSeparator}/>
                    <div class={styles.chipsContainer}>
                        {chips.map(chip => {
                            function handleChipClick(event: MouseEvent) {
                                event.stopPropagation();

                                onChange(chip.value);
                            }

                            return (
                                <Chip
                                    key={chip.value}
                                    background={chip.value === value ? ChipBackground.Blue : ChipBackground.Gray}
                                    text={chip.label}
                                    onClick={handleChipClick}/>
                            );
                        })}
                    </div>
                </>
            )}
        </button>
    );
}

export default TogglePill;
